/** Irelia AbilitySpec seed kit (wiki residual numeric align). */
export const IRELIA_ABILITY_DEFS = [
  {
    id: 'irelia_q',
    champKey: 'irelia',
    slot: 'Q',
    name: 'Bladesurge',
    targeting: 'blink',
    range: 600,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 10,
    manaCost: 15,
    vfxId: 'irelia_q',
    status: 'wired'
  },
  {
    id: 'irelia_w',
    champKey: 'irelia',
    slot: 'W',
    name: 'Defiant Dance',
    targeting: 'self_buff',
    range: 0,
    castTime: 0,
    travelSpeed: null,
    width: null,
    radius: null,
    cooldown: 20,
    duration: 1.5,
    manaCost: 70,
    vfxId: 'irelia_w',
    status: 'wired'
  },
  {
    id: 'irelia_e',
    champKey: 'irelia',
    slot: 'E',
    name: 'Flawless Duet',
    targeting: 'dual_blade',
    range: 775,
    castTime: 0,
    travelSpeed: 2000,
    width: null,
    radius: 90,
    cooldown: 16,
    manaCost: 50,
    vfxId: 'irelia_e',
    status: 'wired',
    bladeMarks: 2
  },
  {
    id: 'irelia_r',
    champKey: 'irelia',
    slot: 'R',
    name: 'Vivid Blade',
    targeting: 'skillshot_line',
    range: 1000,
    castTime: 0.4,
    travelSpeed: 2000,
    width: 320,
    radius: 160,
    cooldown: 125,
    manaCost: 100,
    vfxId: 'irelia_r',
    status: 'wired'
  }
];
